<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.id }} — {{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const DAMAGES = 'get_damages.php'
	const ACT_LOCATION = 'get_act_location.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'damageReason',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: '',
			dmg_id: ''
		},
		methods: {
			change () {
				EventBus.$emit(`edit_damages`, {index: this.line_count, value: this.selected})
			}
		},
		created () {
			if(this.$parent.data_location.damage_reason == null)
			{
				EventBus.$on('fetch_damage_reason_complete', (data) => {
					if (data) {
						this.options = [{id: '', name: ''}, ...data]
						this.selected = this.dmg_id ? this.dmg_id : ''
					}
					else {
						this.options = []
						this.selected = ''
					}
					EventBus.$off('fetch_damage_reason_complete')
				})
			}
			else
			{
				let data = this.$parent.data_location.damage_reason
				if (data) {
					this.options = [{id: '', name: ''}, ...data]
					this.selected = this.dmg_id ? this.dmg_id : ''
				}
				else {
					this.options = []
					this.selected = ''
				}
			}
		},
		beforeDestroy () {
			EventBus.$off('fetch_damage_reason_complete')
		}
	}
</script>


// WEBPACK FOOTER //
// damageReason.vue?dc317dd4